import DataAccess from "../DataAccessStrategy";

export default class ManutencaoVeiculo extends DataAccess {
  constructor() {
    super("ManutencaoVeiculo", {
      id: Number,
      shouldSync: Boolean,
      updatedDate: Date,
      nome: String,
      antecipacaoPorDias: String,
      diasParados: String,
      antecipacaoPorUtilizacao: String,
      descricao: String,
      valor: String,
      ativo: Boolean,
      numeroDocumento: String,
      quilometragem: String,
      VeiculoId: Number,
      hashRotaAbertura: String,
      hash: String,
    });
    this.filterDifferentHashRotaAbertura =
      this.filterDifferentHashRotaAbertura.bind(this);
    this.filterByHashRotaAbertura = this.filterByHashRotaAbertura.bind(this);
  }

  async filterDifferentHashRotaAbertura(routeOpening) {
    if (routeOpening) {
      return await this.model
        .where("hashRotaAbertura")
        .notEqual(routeOpening.hash)
        .filter((a) => a.ativo != false)
        .toArray();
    } else {
      return await this.model.toArray();
    }
  }
  async filterByHashRotaAbertura(routeOpening) {
    if (routeOpening) {
      return await this.model
        .where("hashRotaAbertura")
        .equals(routeOpening.hash)
        .filter((a) => a.ativo != false)
        .toArray();
    } else {
      return await this.model.toArray();
    }
  }
}
